<template>
  <div>
    <div class="row login-box">
      <div class="col-lg-6 col-md-12 bg-img none-992">
        <div class="info">
          <div class="logo clearfix">
            <a href="/dang-nhap">
              <img src="/assets/img/logos/logo.png" alt="logo">
            </a>
          </div>
          <div class="btn-section clearfix" v-if="user.account">
            <router-link to="/thong-tin-tai-khoan"
              :class="this.$route.path == '/thong-tin-tai-khoan' ? `default-bg` : ''" class="link-btn btn-1">Tài khoản
            </router-link>
            <div class="clearfix"></div>
            <router-link to="/ip-bonus"
              :class="this.$route.path == '/ip-bonus' ? `default-bg` : ''" class="link-btn btn-1">IP Bonus
            </router-link>
            <div class="clearfix"></div>
            <router-link to="/doi-mat-khau" :class="this.$route.path == '/doi-mat-khau' ? `default-bg` : ''"
              class="link-btn btn-1">Đổi mật khẩu</router-link>
            <div class="clearfix"></div>
            <router-link to="/nap-the" :class="this.$route.path == '/nap-the' ? `default-bg` : ''"
              class="link-btn btn-1">Nạp thẻ</router-link>
            <div class="clearfix"></div>
            <router-link to="/qua-tang-hang-ngay" :class="this.$route.path == '/qua-tang-hang-ngay' ? `default-bg` : ''"
              class="link-btn btn-1">Quà tặng
            </router-link>
            <div class="clearfix"></div>
            <a onClick="return confirm('Bạn chắc chắn muốn thoát?');" href="/logout" class="link-btn btn-1">Thoát</a>
            <div class="clearfix"></div>
          </div>
          <div class="btn-section clearfix" v-else>
            <router-link to="/dang-nhap"
              :class="this.$route.path == '/dang-nhap' || this.$route.path == '/' ? `default-bg` : ''"
              v-if="!user.account" class="link-btn btn-1">Đăng Nhập</router-link>
            <div class="clearfix"></div>
            <router-link to="/dang-ky" :class="this.$route.path == '/dang-ky' ? `default-bg` : ''" v-if="!user.account"
              class="link-btn btn-1">Đăng Ký</router-link>
            <div class="clearfix"></div>
          </div>
          <ul class="social-list">
            <li>
              <a href="https://www.facebook.com/groups/tantuanh" target="_blank" class="facebook-bg">
                <i class="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/b.r.u.c.e.l.e.e.9.x/" target="_blank" class="twitter-bg">
                <i class="fa fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="#" class="google-bg">
                <i class="fa fa-google"></i>
              </a>
            </li>
            <li>
              <a href="#" class="linkedin-bg">
                <i class="fa fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="#" class="pinterest-bg">
                <i class="fa fa-pinterest"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 bg-color-16 align-self-center">
        <router-view :tqc_api="tqc_api" :token="token" :user="user" @get-info="getInfo"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'app',
    components: {},
    mounted() {
      if (localStorage.token) {
        this.token = localStorage.token
      }
    },
    created() {
      this.loadTimeLine()
    },
    methods: {
      getInfo(page) {
        var currentTime = Math.floor(Date.now() / 1000)

        if (localStorage.get_info_latest == undefined) {
          localStorage.get_info_latest = currentTime
        }

        if ((currentTime - parseInt(localStorage.get_info_latest) < 15) && localStorage.user) {
          // this.user = JSON.parse(localStorage.user)
          // return false
        }

        if (localStorage.token) {
          this.token = localStorage.token

          axios.post(`${this.tqc_api}me`, {
            token: this.token
          }).then(({
            data
          }) => {
            this.user = data
            localStorage.user = JSON.stringify(data)
            localStorage.get_info_latest = currentTime

            if (page != undefined && page == 'login') {
              this.$router.push({
                name: 'Account'
              })
            }
          }).catch(() => {
            if (this.$route.path != '/') {
              localStorage.token = ''
              this.$router.push({
                name: 'Login'
              })
            }
          })
        } else {
          if (this.$route.path != '/') {
            this.$router.push({
              name: 'Login'
            })
          }
        }
      },
      loadTimeLine() {
        var start = new Date("05/05/2017");
        var today = new Date();
        var timeDiff = today.getTime() - start.getTime();
        this.timeLine = Math.ceil(timeDiff / (1000 * 3600 * 24))
      }
    },
    data() {
      return {
        tqc_api: 'https://api.3kprivate.com/',
        token: '',
        user: {},
        timeLine: 820
      }
    }
  }
</script>